"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _MatrixClientPeg = require("../../MatrixClientPeg");

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _MatrixClientBackedSettingsHandler = require("./MatrixClientBackedSettingsHandler");

var _MatrixClientBackedSettingsHandler2 = _interopRequireDefault(_MatrixClientBackedSettingsHandler);

var _SettingsStore = require("../SettingsStore");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Gets and sets settings at the "account" level for the current user.
 * This handler does not make use of the roomId parameter.
 */
var AccountSettingsHandler = function (_MatrixClientBackedSe) {
    (0, _inherits3.default)(AccountSettingsHandler, _MatrixClientBackedSe);

    function AccountSettingsHandler(watchManager) {
        (0, _classCallCheck3.default)(this, AccountSettingsHandler);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AccountSettingsHandler.__proto__ || (0, _getPrototypeOf2.default)(AccountSettingsHandler)).call(this));

        _this._watchers = watchManager;
        _this._onAccountData = _this._onAccountData.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(AccountSettingsHandler, [{
        key: "initMatrixClient",
        value: function initMatrixClient(oldClient, newClient) {
            if (oldClient) {
                oldClient.removeListener("accountData", this._onAccountData);
            }

            newClient.on("accountData", this._onAccountData);
        }
    }, {
        key: "_onAccountData",
        value: function _onAccountData(event) {
            if (event.getType() === "org.matrix.preview_urls") {
                var val = event.getContent()['disable'];
                if (typeof val !== "boolean") {
                    val = null;
                } else {
                    val = !val;
                }

                this._watchers.notifyUpdate("urlPreviewsEnabled", null, _SettingsStore.SettingLevel.ACCOUNT, val);
            } else if (event.getType() === "im.vector.web.settings") {
                // We can't really discern what changed, so trigger updates for everything
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(event.getContent())), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var settingName = _step.value;

                        var _val = event.getContent()[settingName];
                        this._watchers.notifyUpdate(settingName, null, _SettingsStore.SettingLevel.ACCOUNT, _val);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    }, {
        key: "getValue",
        value: function getValue(settingName, roomId) {
            // Special case URL previews
            if (settingName === "urlPreviewsEnabled") {
                var content = this._getSettings("org.matrix.preview_urls") || {};

                // Check to make sure that we actually got a boolean
                if (typeof content['disable'] !== "boolean") return null;
                return !content['disable'];
            }

            var settings = this._getSettings() || {};
            var preferredValue = settings[settingName];

            if (preferredValue === null || preferredValue === undefined) {
                // Honour the old setting on read only
                if (settingName === "hideAvatarChanges" || settingName === "hideDisplaynameChanges") {
                    preferredValue = settings["hideAvatarDisplaynameChanges"];
                }
            }

            return preferredValue;
        }
    }, {
        key: "setValue",
        value: function setValue(settingName, roomId, newValue) {
            // Special case URL previews
            if (settingName === "urlPreviewsEnabled") {
                var _content = this._getSettings("org.matrix.preview_urls") || {};
                _content['disable'] = !newValue;
                return _MatrixClientPeg2.default.get().setAccountData("org.matrix.preview_urls", _content);
            }

            var content = this._getSettings() || {};
            content[settingName] = newValue;
            return _MatrixClientPeg2.default.get().setAccountData("im.vector.web.settings", content);
        }
    }, {
        key: "canSetValue",
        value: function canSetValue(settingName, roomId) {
            return true; // It's their account, so they should be able to
        }
    }, {
        key: "isSupported",
        value: function isSupported() {
            var cli = _MatrixClientPeg2.default.get();
            return cli !== undefined && cli !== null;
        }
    }, {
        key: "_getSettings",
        value: function _getSettings() {
            var eventType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "im.vector.web.settings";

            var cli = _MatrixClientPeg2.default.get();
            if (!cli) return null;

            var event = cli.getAccountData(eventType);
            if (!event || !event.getContent()) return null;
            return event.getContent();
        }
    }]);
    return AccountSettingsHandler;
}(_MatrixClientBackedSettingsHandler2.default); /*
                                                Copyright 2017 Travis Ralston
                                                Copyright 2019 New Vector Ltd.
                                                
                                                Licensed under the Apache License, Version 2.0 (the "License");
                                                you may not use this file except in compliance with the License.
                                                You may obtain a copy of the License at
                                                
                                                    http://www.apache.org/licenses/LICENSE-2.0
                                                
                                                Unless required by applicable law or agreed to in writing, software
                                                distributed under the License is distributed on an "AS IS" BASIS,
                                                WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                                See the License for the specific language governing permissions and
                                                limitations under the License.
                                                */

exports.default = AccountSettingsHandler;
module.exports = exports["default"];
//# sourceMappingURL=AccountSettingsHandler.js.map